<div class="module-thumbnail" [ngClass]="{ 'module-thumbnail-disabled': disabled, 'selected-module-thumbnail': isSelected }">
  <img class="module-thumbnail-image" [src]="module.iconUrl" />
  <span class="name">{{ module.name | capitalizeFirst }}</span>
</div>
